
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activity",
      function () {
        return require("private-next-pages/activity/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activity"])
      });
    }
  